import React, { useEffect } from "react";
import { ColorPicker } from "views/components";
import { COLOR_SAMPLE_TOOLTIP_ID } from "views/components/colorSample";
import { formatColorTooltip } from "lib/Colors/formatColorTooltip";
import { scheduleTooltipRebuild } from "views/components/Tooltip";
import CrossThinIcon from "views/components/icons/CrossThinIcon";
import style from "./style.module.css";

export default function BrandKitColorGroupColor({
  color,
  isRemovable,
  isSelected,
  onClick,
  onPickerChange,
  onPickerClose,
  onRemove
}) {
  const tooltipText = formatColorTooltip(color);
  const tooltipProps = tooltipText
    ? { "data-tip": tooltipText, "data-for": COLOR_SAMPLE_TOOLTIP_ID }
    : {};

  useEffect(() => {
    if (tooltipText) scheduleTooltipRebuild();
  }, [tooltipText]);

  return (
    <div className={style.colorsGroupColor}>
      <div
        className={style.colorsGroupColorCircle}
        data-is-white={
          /#F{3}/i.test(color) || /#F{6}/i.test(color) || /^white$/i.test(color)
        }
        {...tooltipProps}
        onClick={onClick}
        style={{ backgroundColor: color }}
      />

      {isRemovable && (
        <div className={style.colorsGroupColorRemove} onClick={onRemove}>
          <CrossThinIcon size="10px" />
        </div>
      )}

      {isSelected && (
        <ColorPicker
          className={style.colorsGroupColorPicker}
          color={color}
          isDisplayHeader
          isSaveButtonHidden
          onChange={onPickerChange}
          onClose={onPickerClose}
          onSave={onPickerClose}
        />
      )}
    </div>
  );
}
